import cx from "classnames";
import { type ComponentProps, forwardRef } from "react";

export const SidebarFooter = forwardRef<HTMLDivElement, ComponentProps<"div">>(
  ({ className, ...props }, ref) => {
    return (
      <div
        ref={ref}
        data-sidebar="footer"
        className={cx(
          // When the sidebar is collapsed to icon mode its visible width
          // is `var(--sidebar-width-icon)` (≈57px). Footer tiles are 32px
          // square with a bordered card shell, so `p-4` (16px on each
          // side) overflows the 57px column and clips the tiles against
          // the sidebar's rounded outer edge — see the "IS" avatar and
          // "Log In" icon being cut off in collapsed state. Drop
          // horizontal padding to `px-2` (8px) when collapsed so 32px
          // tiles center cleanly within the 57px rail; keep `p-4` for
          // the expanded state.
          "flex flex-col gap-2 p-4 group-data-[collapsible=icon]:px-2",
          className,
        )}
        {...props}
      />
    );
  },
);
SidebarFooter.displayName = "SidebarFooter";
